import { useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useQuery } from "react-query";
import { toast } from "sonner";

import { dinhMucTonKhoApi } from "src/1/apis/dinh_muc_ton_kho.api";
import { nhomNguyenVatLieuApi } from "src/1/apis/nhom_nguyen_vat_lieu.api";
import { CModal, usePermissionCheck } from "src/1/common/components/others";
import { Magnifying } from "src/common/assets/icons";
import { CButton, CInput, CSelect } from "src/common/components/controls";
import { CActionGroup, CDialog } from "src/common/components/others";
import { ENTITY_GROUP_CODE, PERMISSION_VALUE } from "src/configs/constant";
import { useGetMyStores } from "src/utils/hooks/options";

import templateFile from "./template.xlsx";

export const DinhMucTonKhoToolbar = ({
  params,
  canAdd,
  canEdit,
  canRemove,
  onAdd,
  onEdit,
  onRemove,
  onSearch,
  refetch,
}) => {
  //#region Data
  const checkPermission = usePermissionCheck();

  const { control, handleSubmit } = useForm({
    defaultValues: params,
  });

  const { stores } = useGetMyStores();

  const { data: groups = [] } = useQuery({
    queryKey: ["danh-sach-tat-ca-nhom-nvl"],
    queryFn: () => nhomNguyenVatLieuApi.getAll(),
    select: (response) =>
      response?.data?.data?.map((e) => ({
        ...e,
        id: e.code,
        value: e.code,
        label: e.name,
      })),
  });

  const [open, setOpen] = useState(false);
  const [selectStore, setSelectStore] = useState("");

  const inputRef = useRef(null);
  //#endregion

  //#region Event
  const onClose = () => setOpen(false);

  const onClick = (state) => {
    switch (state) {
      case "add":
        return onAdd();
      case "edit":
        return onEdit();
      case "remove":
        return onRemove();
      case "print":
      default:
        return;
    }
  };

  const search = handleSubmit((d) => onSearch(d));

  const onDownloadTemplate = () => {
    const link = document.createElement("a");
    link.href = templateFile;
    link.download = "template_dinh_muc_ton_kho.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const onSelectFile = () => inputRef.current?.click();

  const handleImport = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      toast.promise(() => dinhMucTonKhoApi.import(selectStore, file), {
        loading: "Đang import dữ liệu...",
        success: () => {
          refetch();
          setOpen(false);
          return "Nhập dữ liệu thành công";
        },
        error: (error) => error?.message || "Có lỗi xảy ra",
        finally: () => (inputRef.current.value = ""),
      });
    }
  };
  //#endregion

  //#region Render
  return (
    <>
      <div>
        <CActionGroup
          onClick={onClick}
          canAdd={
            canAdd &&
            checkPermission({
              [ENTITY_GROUP_CODE.DINH_MUC_TON_KHO]: PERMISSION_VALUE.CREATE,
            })
          }
          canEdit={
            canEdit &&
            checkPermission({
              [ENTITY_GROUP_CODE.DINH_MUC_TON_KHO]: PERMISSION_VALUE.UPDATE,
            })
          }
          canRemove={
            canRemove &&
            checkPermission({
              [ENTITY_GROUP_CODE.DINH_MUC_TON_KHO]: PERMISSION_VALUE.DELETE,
            })
          }
        />
      </div>

      <div className="mt-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Controller
            name="nvlId"
            control={control}
            render={({ field }) => (
              <CInput
                {...field}
                label="Mã NVL"
                placeholder="Tìm kiếm theo mã NVL"
              />
            )}
          />
          <Controller
            name="name"
            control={control}
            render={({ field }) => (
              <CInput
                {...field}
                label="Tên NVL"
                placeholder="Tìm kiếm theo tên NVL"
              />
            )}
          />
          <Controller
            name="storeCode"
            control={control}
            render={({ field }) => (
              <CSelect
                {...field}
                label="Chi nhánh"
                options={stores}
                optionAll
                display="label"
                select="value"
                placeholder="Tất cả"
                className="min-w-[250px]"
              />
            )}
          />
          {/* <Controller
            name="groupCode"
            control={control}
            render={({ field }) => (
              <CSelect
                {...field}
                label="Nhóm NVL"
                options={groups}
                optionAll
                display="label"
                select="value"
                placeholder="Tất cả"
                className="min-w-[250px]"
              />
            )}
          /> */}
        </div>
        <div className="flex flex-row gap-3 [&_button]:mr-0">
          <CButton onClick={onDownloadTemplate} variant="outline">
            Tải file mẫu
          </CButton>
          <CButton
            onClick={() => {
              setSelectStore(stores?.[0]?.value);
              setOpen(true);
            }}
          >
            Import
          </CButton>
          <input
            type="file"
            hidden
            ref={inputRef}
            accept=".xls,.xlsx"
            onChange={handleImport}
          />
          <CButton icon={<Magnifying />} onClick={search} className="m-0">
            Tìm kiếm
          </CButton>
        </div>
      </div>

      <CModal
        open={open}
        onClose={onClose}
        onSubmit={onSelectFile}
        title="Chọn chi nhánh"
        size="sm"
        submitLabel="Import"
      >
        <CSelect
          value={selectStore}
          onChange={setSelectStore}
          select="value"
          options={stores}
        />
      </CModal>
    </>
  );
  //#endregion
};
